import GjwPagination from './src/GjwPagination'

GjwPagination.install = function(Vue) {
  Vue.component(GjwPagination.name, GjwPagination)
}

export default GjwPagination
